import script from "./ChangePhone.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChangePhone.vue?vue&type=script&lang=ts&setup=true"

import "./ChangePhone.vue?vue&type=style&index=0&id=930c94da&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-930c94da"]])

export default __exports__